import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";
const getTranslateX = ({ checked, small }) => {
  if (!checked) {
    return "1px";
  } else if (!small) {
    return "25px";
  } else {
    return "12px";
  }
};
const getBackgroundColor = ({
  checked,
  currentColor
}) => {
  if (checked) {
    return currentColor != null ? currentColor : color("brand");
  } else {
    return color("bg-medium");
  }
};
export const ToggleRoot = styled.input`
  appearance: none;
  position: relative;
  display: inline-block;
  color: ${(props) => {
  var _a;
  return (_a = props.currentColor) != null ? _a : color("brand");
}};
  cursor: pointer;
  width: ${(props) => props.small ? "28px" : "48px"};
  height: ${(props) => props.small ? "17px" : "24px"};
  border-radius: 99px;
  border: 1px solid ${color("border")};
  background-color: ${color("bg-medium")};
  background-color: ${getBackgroundColor};
  transition: background-color 0.3s;
  flex-shrink: 0;

  &:after {
    content: "";
    width: ${(props) => props.small ? "13px" : "20px"};
    height: ${(props) => props.small ? "13px" : "20px"};
    border-radius: 99px;
    position: absolute;
    top: 1px;
    transform: translateX(${getTranslateX});
    background-color: ${color("white")};
    transition: transform 0.3s;
    box-shadow: 2px 2px 6px ${color("shadow")};
  }

  &:focus {
    outline: 2px solid ${() => color("focus")};
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
`;
